import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Campaign, CampaignCreate, CampaignFilter } from '../data/campaign';

export function createCampaignService(client: AxiosInstance) {
  return createCrudService<Campaign, CampaignCreate, CampaignFilter>(
    client,
    '/crm/Campaign',
    'id',
  );
}

export type CampaignService = CrudService<Campaign, CampaignCreate, CampaignFilter>;
